import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { EtabLayout } from "@/components/EtabLayout";
import { PatientLayout } from "@/components/PatientLayout";
import { StarOfLife } from "@/components/Logo";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Jeregul from "@/pages/Jeregul";
import Laregul from "@/pages/Laregul";
import Vehicles from "@/pages/Vehicles";
import Drivers from "@/pages/Drivers";
import Patients from "@/pages/Patients";
import Billing from "@/pages/Billing";
import Corrections from "@/pages/Corrections";
import Settings from "@/pages/Settings";
import TestGenerator from "@/pages/TestGenerator";
import ProTribus from "@/pages/ProTribus";
import Bourse from "@/pages/Bourse";
import Export from "@/pages/Export";
import Annuaire from "@/pages/Annuaire";
import Statistiques from "@/pages/Statistiques";
import Coffre from "@/pages/patient/Coffre";
import Sorties from "@/pages/etab/Sorties";
import Tribu from "@/pages/etab/Tribu";
import Demandes from "@/pages/etab/Demandes";
import Reserver from "@/pages/patient/Reserver";
import MesCourses from "@/pages/patient/MesCourses";
import Profil from "@/pages/patient/Profil";
import DriverApp from "@/pages/driver/DriverApp";
import InstallPage from "@/pages/InstallPage";
import AuthCallback from "@/pages/AuthCallback";
import { AdminLayout } from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPayments from "@/pages/admin/AdminPayments";
import { SectionGate } from "@/components/SectionGate";


function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-pulse"><StarOfLife size={56} /></div>
    </div>
  );
}

function GerantRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<SectionGate section="tableau-de-bord"><Dashboard /></SectionGate>} />
        <Route path="/jeregul" element={<SectionGate section="jeregul"><Jeregul /></SectionGate>} />
        <Route path="/laregul" element={<SectionGate section="laregul"><Laregul /></SectionGate>} />
        <Route path="/corrections" element={<SectionGate section="corrections"><Corrections /></SectionGate>} />
        <Route path="/tribus" element={<SectionGate section="tribus"><ProTribus /></SectionGate>} />
        <Route path="/bourse" element={<SectionGate section="bourse"><Bourse /></SectionGate>} />
        <Route path="/vehicules" element={<SectionGate section="vehicules"><Vehicles /></SectionGate>} />
        <Route path="/conducteurs" element={<SectionGate section="conducteurs"><Drivers /></SectionGate>} />
        <Route path="/patients" element={<SectionGate section="patients"><Patients /></SectionGate>} />
        <Route path="/annuaire" element={<SectionGate section="annuaire"><Annuaire /></SectionGate>} />
        <Route path="/export" element={<SectionGate section="export"><Export /></SectionGate>} />
        <Route path="/statistiques" element={<SectionGate section="statistiques"><Statistiques /></SectionGate>} />
        <Route path="/test" element={<SectionGate section="test"><TestGenerator /></SectionGate>} />
        <Route path="/abonnement" element={<SectionGate section="abonnement"><Billing /></SectionGate>} />
        <Route path="/reglages" element={<SectionGate section="reglages"><Settings /></SectionGate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function EtabRoutes() {
  return (
    <EtabLayout>
      <Routes>
        <Route path="/" element={<Sorties />} />
        <Route path="/demandes" element={<Demandes />} />
        <Route path="/tribu" element={<Tribu />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </EtabLayout>
  );
}

function PatientRoutes() {
  return (
    <PatientLayout>
      <Routes>
        <Route path="/" element={<Reserver />} />
        <Route path="/mes-courses" element={<MesCourses />} />
        <Route path="/coffre" element={<Coffre />} />
        <Route path="/profil" element={<Profil />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </PatientLayout>
  );
}

function AdminRoutes() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/societes" element={<AdminCompanies />} />
        <Route path="/utilisateurs" element={<AdminUsers />} />
        <Route path="/paiements" element={<AdminPayments />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AdminLayout>
  );
}

function AppShell() {
  const { user, ready } = useAuth();
  const location = useLocation();
  // Retour de la connexion Google : traiter le fragment AVANT tout routage.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (location.pathname === "/install") return <InstallPage />;
  if (!ready || user === null) return <Loader />;
  if (user === false) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }
  if (user.role === "driver") {
    return (
      <Routes>
        <Route path="*" element={<DriverApp />} />
      </Routes>
    );
  }
  if (user.role === "etablissement") return <EtabRoutes />;
  if (user.role === "patient") return <PatientRoutes />;
  if (user.role === "admin") return <AdminRoutes />;
  return <GerantRoutes />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
